module.exports = new __parcel__URL__("shop_back_button.6875a205.png").toString();